import { createSlice } from "@reduxjs/toolkit";

export const crops_image_library = createSlice({
  name: "crops_image_library",
  initialState: {
    value: {
      status: false,
      data: [],
      currentPage: 1,
      pageCount: 1,
      totalCount: 1,
      limit: 20,
      paginatedData: [
        {
          currentPage: 1,
          pageData: [],
        },
      ],
    },
  },
  reducers: {
    updateStoreCropsImageLibary: (state, action) => {
      state.value.status = true;
      if (action.payload?.data?.length > 0) {
        if (action.payload?.currentPage === 1) {
          state.value.paginatedData = [
            {
              currentPage: action.payload?.currentPage,
              pageData: action.payload?.data,
            },
          ];
        } else {
          state.value.paginatedData = [
            ...state.value.paginatedData,
            {
              currentPage: action.payload?.currentPage,
              pageData: action.payload?.data,
            },
          ];
        }
        state.value.data = action.payload?.data;
        state.value.currentPage = action.payload?.currentPage;
        state.value.pageCount = action.payload?.pageCount;
        state.value.totalCount = action.payload?.totalCount;
      }
    },
  },
});

export const { updateStoreCropsImageLibary } = crops_image_library.actions;

export default crops_image_library.reducer;
